"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURES = {
    BACKGROUND: 'BG',
    ACCESSORIES: 'AC',
    EXTERIOR: 'EX',
    INTERIOR: 'IN',
    ROOF: 'RO',
    BACKGROUND_URL_PARAMS: 'bg',
    ROOF_URL_PARAMS: 'rf',
};
